import { LOCALES } from "../constants/locales.constants";
export function prepareApplications(data) {
    return data
        .sort((a, b) => a.order - b.order)
        .reduce((acc, app) => {
        acc[app.name] = app;
        return acc;
    }, {});
}
export function prepareMenu(data) {
    return data.reduce((acc, app) => {
        acc[app.name] = {
            path: app.path,
            title: app.title,
            items: app.menu,
        };
        return acc;
    }, {});
}
export function getInitialData(context) {
    return context.rest
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        .get("/api/config", { baseURL: null })
        .then(({ data }) => ({
        applications: prepareApplications(data.data),
        menu: prepareMenu(data.data),
    }))
        .catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
        console.error(`Can't get applications. Empty response used as fallback.`);
        return {
            applications: {},
            menu: {},
        };
    });
}
export function getScopes(context, locale = LOCALES.RU) {
    const params = new URLSearchParams({ locale });
    return context.rest
        .get("/shared/permissions/scopes", { params })
        .then(({ data }) => data.data)
        .catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
        console.error(`Can't get scopes. Empty response used as fallback.`);
        return {};
    });
}
export function getCabinetLinks(context, locale = LOCALES.RU) {
    const params = new URLSearchParams({ locale });
    return context.rest
        .get(context.configuration.original.CMS_SERVER + "/cabinet-links", {
        params,
    })
        .then(({ data }) => data.data)
        .catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
        console.error(`Can't get cabinet-links. Empty response used as fallback.`);
        return [];
    });
}
export function getMenus(context, locale = LOCALES.RU) {
    const params = new URLSearchParams({ locale });
    return context.rest
        .get(context.configuration.original.CMS_SERVER + "/menus", { params })
        .then(({ data }) => data.data)
        .catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
        console.error(`Can't get menus. Empty response used as fallback.`);
        return [];
    });
}
export function getFeatureFlags(context, locale = LOCALES.RU) {
    const params = new URLSearchParams({ locale });
    return context.rest
        .get(context.configuration.original.CMS_SERVER + "/feature-flags", {
        params,
    })
        .then(({ data }) => data.data)
        .catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
        console.error(`Can't get menus. Empty response used as fallback.`);
        return [];
    });
}
export function getMoexServices(context, locale = LOCALES.RU) {
    const params = new URLSearchParams({ locale });
    return context.rest
        .get(context.configuration.original.CMS_SERVER + "/moex-services", {
        params,
    })
        .then(({ data }) => data.data)
        .catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
        console.error(`Can't get moex-services. Empty response used as fallback.`);
        return [];
    });
}
export function getProducts(context, locale = LOCALES.RU) {
    const params = new URLSearchParams({ locale });
    return context.rest
        .get(context.configuration.original.CMS_SERVER + "/products", { params })
        .then(({ data }) => data.data)
        .catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
        console.error(`Can't get products. Empty response used as fallback.`);
        return [];
    });
}
export function getAsideMenu(context, locale = LOCALES.RU) {
    const params = new URLSearchParams({ locale });
    return context.rest
        .get(context.configuration.original.CMS_SERVER + "/aside-menus", { params })
        .then(({ data }) => data.data)
        .catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
        console.error(`Can't get aside menu. Empty response used as fallback.`);
        return [];
    });
}
export function getNotifications(context, locale = LOCALES.RU) {
    const params = new URLSearchParams({ locale });
    return context.rest
        .get(context.configuration.original.CMS_SERVER + "/notices", { params })
        .then(({ data }) => data.data)
        .catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
        console.error(`Can't get notifications. Empty response used as fallback.`);
        return [];
    });
}
export function getIncapsulatedAppsCodes(context, locale = LOCALES.RU) {
    const params = new URLSearchParams({ locale });
    return context.rest
        .get(context.configuration.original.CMS_SERVER + "/incapsulated-microfrontends", { params })
        .then(({ data }) => data.data)
        .catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
        console.error(`Can't get notifications. Empty response used as fallback.`);
        return [];
    });
}
export async function getDataFromStrapi(context, locale = LOCALES.RU) {
    try {
        const [scopes, cabinetLinks, moexServices, menus, featureFlags, asideMenus, products, notifications, incapsulatedAppsCodes,] = await Promise.allSettled([
            getScopes(context, locale),
            getCabinetLinks(context, locale),
            getMoexServices(context, locale),
            getMenus(context, locale),
            getFeatureFlags(context, locale),
            getAsideMenu(context, locale),
            getProducts(context, locale),
            getNotifications(context, locale),
            getIncapsulatedAppsCodes(context, locale),
        ]).then((res) => res.map((result) => result.value));
        const data = {
            scopes,
            menus,
            cabinetLinks,
            featureFlags,
            moexServices,
            asideMenus,
            products,
            notifications,
            incapsulatedAppsCodes
        };
        return data;
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        console.error(`Can't get data from Strapi. Empty response used as fallback.`);
        return {};
    }
}
